module.exports = __webpack_public_path__ + "static/media/CAM_LT_07.d896d2f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clothes/pants/CAM_LT_07.png
// module id = 72
// module chunks = 0